/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserWalletListRespVo } from './UserWalletListRespVo';
import {
    UserWalletListRespVoFromJSON,
    UserWalletListRespVoFromJSONTyped,
    UserWalletListRespVoToJSON,
    UserWalletListRespVoToJSONTyped,
} from './UserWalletListRespVo';

/**
 * 
 * @export
 * @interface PageDataUserWalletListRespVo
 */
export interface PageDataUserWalletListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataUserWalletListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataUserWalletListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataUserWalletListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<UserWalletListRespVo>}
     * @memberof PageDataUserWalletListRespVo
     */
    records?: Array<UserWalletListRespVo>;
}

/**
 * Check if a given object implements the PageDataUserWalletListRespVo interface.
 */
export function instanceOfPageDataUserWalletListRespVo(value: object): value is PageDataUserWalletListRespVo {
    return true;
}

export function PageDataUserWalletListRespVoFromJSON(json: any): PageDataUserWalletListRespVo {
    return PageDataUserWalletListRespVoFromJSONTyped(json, false);
}

export function PageDataUserWalletListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataUserWalletListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UserWalletListRespVoFromJSON)),
    };
}

export function PageDataUserWalletListRespVoToJSON(json: any): PageDataUserWalletListRespVo {
    return PageDataUserWalletListRespVoToJSONTyped(json, false);
}

export function PageDataUserWalletListRespVoToJSONTyped(value?: PageDataUserWalletListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UserWalletListRespVoToJSON)),
    };
}

